import React from "react";
import styled from "styled-components";

export default styled.div`
    label {
        width: 100%;
        display: block;
        margin-bottom: 10px;

        small {
            color: #599ed8;
            font-size: 31px;
            line-height: 0px;
            top: 5px;
            position: relative;
            left: 3px;
        }
    }
    &.half {

        width: calc(100% + 30px);
        margin-left: -15px;

        label {

            margin-left: 15px;
        }
    }

    input {
        width: 100%;
        height: 43px;
        border: 2px solid rgb(203 203 203);
        margin-bottom: 20px;
        padding: 15px;



        &.half {
            width: calc(50% - 30px);
            float: left;
            margin: 0 15px;
        margin-bottom: 10px;
        }
    }

    select {
        widtH: 100%;
        height: 43px;
        margin-bottom: 20px;
        border: 2px solid rgb(203 203 203);
        padding: 10px 15px;
    }

    textarea {
        width: 100%;
        height: 150px;
        resize: none;
        margin-bottom: 20px;
        border: 2px solid rgb(203 203 203);
        padding: 15px;
    }

`;